// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tgdyw","question":"styles_question__3dnYk","inputVisibleButton":"styles_inputVisibleButton__2KdHm","note":"styles_note__2menz"};